// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2PBqP","modalFooterButton":"ModalNotes_modalFooterButton__2f1FS"};